var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 13H10.8571M5.14286 13C3.95939 13 3 12.0406 3 10.8571V5.14286C3 3.95939 3.95939 3 5.14286 3H9.1124C9.68072 3 10.2258 3.22576 10.6276 3.62763L12.3724 5.37237C12.7742 5.77424 13 6.31928 13 6.8876V10.8571C13 12.0406 12.0406 13 10.8571 13M5.14286 13L5.14274 10.1427C5.14274 9.35371 5.78233 8.71411 6.57131 8.71411H9.42846C10.2174 8.71411 10.857 9.3537 10.857 10.1427L10.8571 13M5.99988 3V4.78571C5.99988 5.1802 6.31967 5.5 6.71416 5.5H9.28559C9.68008 5.5 9.99988 5.1802 9.99988 4.78571V3",
    stroke: "white",
    strokeWidth: 0.857143
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.5cb505c3d0568aa5a514de0d136afed3.svg";
export { ForwardRef as ReactComponent };